import * as types from "./compare.actionTypes";

export const addHospitalToCompare = (hospitals) => ({
  type: types.ADD_HOSPITAL_TO_COMPARE,
  payload: Array.isArray(hospitals) ? hospitals : [hospitals],
});

export const removeHospitalFromCompare = (ids) => ({
  type: types.REMOVE_HOSPITAL_FROM_COMPARE,
  payload: Array.isArray(ids) ? ids : [ids],
});

export const clearHospitalsCompare = () => ({
  type: types.CLEAR_HOSPITALS_COMPARE,
});

export const updateHospitalInCompare = (newHospital, index) => ({
  type: types.UPDATE_HOSPITAL_IN_COMPARE,
  payload: { newHospital, index },
});

export const addNewHospital = (index) => ({
  type: types.ADD_NEW_HOSPITAL,
  payload: index,
});

export const removeEmptyHospitals = () => ({
  type: types.REMOVE_EMPTY_HOSPITALS,
});